var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountIconPatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.999,
    height: 32,
    viewBox: "0 0 40.999 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pexels-kampus-production-5940841",
    d: "M-12522-104.714c1.922,10.53,2.629,14.451,4.868,18.252s4.163,5.424,15.692,1.787,11.009-3.1,14.668-4.595,6.214-3.255,5.061-9.445-.628-4.262-1.409-6.892-1.409-4.148-9.991-5.744-17.1-3.17-21.523-3.255S-12523.918-115.244-12522-104.714Z",
    transform: "translate(12522.428 114.638)",
    fill: "#ff8289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountIconPatch);
export default __webpack_public_path__ + "static/media/count_icon_patch.813e35caac1d86a96cb33a73be6d968e.svg";
export { ForwardRef as ReactComponent };